import React, {useState, useEffect} from 'react';
import {Link} from "react-router-dom";
import {routes} from '../../Constants/Constants';
import {
    Wrapper,
    LoginC,
    Header,
    Text,
    AboutUs,
    HowItWorks,
    Platforms,
    Title,
    Description,
    HeaderDescription,
    LoginButton
} from "../Styles";
import {auth} from '../../Core/Actions/Auth';
import {useDispatch} from "react-redux";
import mobileAndroid from '../../Assets/mobileAndroid.svg';
import how from '../../Assets/how.svg';
import about from '../../Assets/about.svg';
import rent from '../../Assets/rent.svg';
import {layoutGenerator} from "react-break";
import Footer from "../Footer/Footer";
import {Button, Modal} from "antd";

const screen = layoutGenerator({
    mobile: 0,
    phablet: 550,
    tablet: 768,
    desktop: 992,
});
const OnMobile = screen.is('mobile');
const OnAtLeastTablet = screen.isAtLeast('tablet');
const Login = () => {
    const [email, setEmail] = useState('');
    const [tokenId, setTokenId] = useState('');
    const [image, setImage] = useState('');
    const [visible, setVisible] = useState(true);
    const newUser = localStorage.getItem('newUser');
    const dispatch = useDispatch();

    const handleModal = () => {
        setVisible(!visible)
        localStorage.setItem('newUser', 'false');
    }

    const responseGoogle = (response) => {
        setImage(response.profileObj.imageUrl)
        setEmail(response.profileObj.email);
        setTokenId(response.tokenId);
    };
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;


    useEffect(() => {
        if (email !== '' && tokenId !=='' && image !=='') {
            dispatch(auth(email, tokenId, image))
        }
    }, [tokenId]);


    return (
        <Wrapper>
            <LoginC>
                <Link to={`${routes.App.Home}`} style={{color: 'white', textDecoration: 'blink'}}>
                    <Text>
                        Shtëpia+
                    </Text>
                </Link>
                <LoginButton
                    clientId= {process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID}
                    buttonText="Sign In with Google"
                    onSuccess={responseGoogle}
                    onFailure={responseGoogle}
                    cookiePolicy={'single_host_origin'}
                />

            </LoginC>
            { /android/i.test(userAgent) && newUser !== 'false' ?   <Modal
                title="Shtëpia+"
                visible={visible}
                onCancel={handleModal}
                footer={[
                    <Button key="back" onClick={handleModal}>
                        Jo
                    </Button>,
                    <Button key="submit" type="primary" onClick={handleModal} >
                        <a href='https://play.google.com/store/apps/details?id=com.shtepiaplus.android&hl=en'
                           target="_blank">  Po </a>
                    </Button>,
                ]}
            >
                <p>Dëshironi të përdorni shërbimin nga aplikacioni?</p>
            </Modal> : null }
            <Header>
                <div>
                    <HeaderDescription>Mirë se erdhet</HeaderDescription>
                    <HeaderDescription style={{marginTop: '-40px'}}>Tek e ardhmja e real estate!</HeaderDescription>
                </div>
                <img src={rent} height={'200px'}/>
            </Header>
            <OnAtLeastTablet>
                <AboutUs>
                    <img src={about} height={'300px'}/>
                    <div>
                        <Title>
                            <strong>Rreth Nesh</strong>
                        </Title>
                        <Description style={{marginLeft: '10%', textAlign: 'left'}}>
                            Shtëpia+ është një projekt që synon të thjeshtoi proçesin e gjetjes së një rezidence. Ne
                            perpunojmë të dhëna nga burime të ndryshme, dhe i mbledhim në një aplikacion të
                            vetëm.</Description>
                    </div>
                </AboutUs>
            </OnAtLeastTablet>
            <OnMobile>
                <AboutUs style={{flexWrap: 'wrap'}}>
                    <img src={about} height={'300px'}/>
                    <div>
                        <Title>
                            <strong>Rreth Nesh</strong>
                        </Title>
                        <Description style={{marginLeft: '10%', textAlign: 'left'}}>
                            Shtëpia+ është një projekt që synon të thjeshtoi proçesin e gjetjes së një residence. Ne
                            perpunojmë të dhëna nga burime të ndryshme, dhe i mbledhim në një aplikacion të
                            vetëm.</Description>

                    </div>
                </AboutUs>
            </OnMobile>
            <div style={{background: 'white'}}>
                <HowItWorks>
                    <div>
                        <Title>
                            <strong>Si funksionon?</strong>
                        </Title>
                        <div style={{width: '100%'}}>
                            <Description>
                                Mjafton që ju të krijoni një llogari.
                            </Description>
                            <br/>
                            <Description style={{marginTop: '-20px'}}>
                                Ne do të bëjmë pjesën tjetër të punës.
                            </Description>
                        </div>
                    </div>
                    <img src={how} height={'300px'}/>
                </HowItWorks>
            </div>
            <Platforms>
                <a href='https://play.google.com/store/apps/details?id=com.shtepiaplus.android&hl=en'
                   target="_blank"><img src={mobileAndroid} height={'300px'}/></a>
                <div>
                    <Title>
                        <strong>Platformat</strong>
                    </Title>
                    <div style={{width: '100%'}}>
                        <Description style={{marginTop: '-20px'}}>
                          Ju mund të përdorni këtë shërbim në platformat web dhe android.
                        </Description>
                    </div>
                </div>
            </Platforms>
           <Footer />
        </Wrapper>
    );
};

export default Login;

